import { createSlice } from '@reduxjs/toolkit';

const emailTypesSlice = createSlice({
  name: 'emailTypes',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchEmailTypesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEmailTypesSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchEmailTypesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchEmailTypesRequest, fetchEmailTypesSuccess, fetchEmailTypesFailure } = emailTypesSlice.actions;
export default emailTypesSlice.reducer;
